import { ChangeDetectionStrategy, Component } from '@angular/core';

import { UiNewButtonBase } from '../base.component';

@Component({
	selector: '[uiNewButtonBasic],[uiNewButton]',
	templateUrl: './basic.component.html',
	styleUrls: ['./basic.component.scss', '../base.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
})
export class UiNewButtonBasicComponent extends UiNewButtonBase {
	protected extraClassesKeys: Array<keyof this> = [];
}
